import * as React from 'react';
import {Link} from '@tanstack/react-router';
import { CircleUserRound } from 'lucide-react';

export type AccountIconButtonProps = {
  isLoggedIn: boolean
}

export default function AccountIconButton(props: AccountIconButtonProps) {
  const to = props.isLoggedIn ? "/account/home" : "/my-account";

  return(<Link to={to}><CircleUserRound size={28} /></Link>)
}
